import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    template
})
export default class {
    constructor ($, toastr, AuthService, TokenService, SiteService, PrivilegeService,
                AuthResource, UserResource, NotificationResource, ngProgressFactory, ModalService, $translate,
                NOTIFICATION_STATUS_ENUM, NOTIFICATION_TRANSPORT_ENUM, COMPANY_ADMIN_LANGUAGE_ENUM) {
        this.$ = $;
        this.AuthService = AuthService;
        this.TokenService = TokenService;
        this.SiteService = SiteService;
        this.PrivilegeService = PrivilegeService;
        this.AuthResource = AuthResource;
        this.UserResource = UserResource;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.NotificationResource = NotificationResource;
        this.toastr = toastr;
        this.NOTIFICATION_STATUS_ENUM = NOTIFICATION_STATUS_ENUM;
        this.NOTIFICATION_TRANSPORT_ENUM = NOTIFICATION_TRANSPORT_ENUM;
        this.COMPANY_ADMIN_LANGUAGE_ENUM = COMPANY_ADMIN_LANGUAGE_ENUM;
        this.loader = ngProgressFactory.createInstance();
    }

    $onInit () {
        this.langOpen = false;
        this.skin = `${SEED_CORE.ENV.SKIN}`;

        this.user = this.TokenService.getUser();
        this.sites = this.SiteService.sites.map(({ id, name }) => ({ id, name }));
        this.activeSiteId = this.TokenService.getActiveSiteId();
        this.showNotifications = false;
        this.notificationsCount = 0;
        this.getNotifications();

        this.languageMap = { ET: 'ee', EN: 'gb', LT: 'lt' };
        this.activeLanguage = this.TokenService.getActiveLanguage();
        const otherLanguages = Object.entries(this.COMPANY_ADMIN_LANGUAGE_ENUM.NAMES)
            .filter(([code]) => code !== this.activeLanguage);
        this.languageLabels = Object.fromEntries([...otherLanguages]);

        const trigger = document.querySelector('.languages-v2 .language-trigger');
        const popover = document.getElementById('language-popover');

        // TBD: Remove once safari version is way above 26.
        this._languagePopoverToggleHandler = (e) => {
            if (e.newState !== 'open') {
                return;
            }
            const rect = trigger.getBoundingClientRect();
            popover.style.top = `${rect.bottom}px`;
            popover.style.left = 'auto';
            popover.style.right = `${window.innerWidth - rect.right}px`;
        };
        popover.addEventListener('beforetoggle', this._languagePopoverToggleHandler);
    }

    $onDestroy () {
        // TBD: Remove once safari version is way above 26.
        const popover = document.getElementById('language-popover');
        if (popover && this._languagePopoverToggleHandler) {
            popover.removeEventListener('beforetoggle', this._languagePopoverToggleHandler);
        }
    }

    toggleLang () {
        this.langOpen = !this.langOpen;
    }

    switchAdminLanguage (code) {
        this.loader.start();
        this.UserResource
            .switchAdminLanguage({ adminLanguage: code })
            .$promise
            .then(() => {
                this.loader.complete();
                window.location.reload(true);
            });
    }

    getNotifications () {
        this.notifications = this.NotificationResource.query({
            status: this.NOTIFICATION_STATUS_ENUM.KEYS.NOT_READ,
            transport: this.NOTIFICATION_TRANSPORT_ENUM.KEYS.FEED,
            pageSize: 0
        });
        if (this.notifications.length > 0) {
            this.notificationsCount = this.notifications.length;
        }
        else {
            this.notifications = this.NotificationResource.query({
                transport: this.NOTIFICATION_TRANSPORT_ENUM.KEYS.FEED,
                pageSize: 5
            });
        }
    }

    getPath (file) {
        return `assets/css/${this.TokenService.getCompanySkin()}/${file}?v=${SEED_CORE.REVISION}`;
    }

    changeActiveSite () {
        this.AuthResource
            .selectSite({}, { siteId: this.activeSiteId })
            .$promise
            .then(() => {
                window.location.reload(true);
            })
            .catch((response) => {
                this.toastr.error(response.data[0].message);
            });
    }

    toggleNotifications () {
        this.showNotifications = !this.showNotifications;
    }

    toggleMenu () {
        const { $ } = window;
        $('html').hasClass('menuopen') ? this.closeMenu() : this.openMenu();
    }

    openMenu () {
        const { $ } = window;
        $('html').addClass('menuopen');
        this.closeUserMenu();
    }

    closeMenu () {
        const { $ } = window;
        $('html').removeClass('menuopen');
    }

    toggleUserMenu () {
        const { $ } = window;
        $('html').hasClass('usermenuopen') ? this.closeUserMenu() : this.openUserMenu();
    }

    openUserMenu () {
        const { $ } = window;
        $('html').addClass('usermenuopen');
        this.closeMenu();
    }

    closeUserMenu () {
        const { $ } = window;
        $('html').removeClass('usermenuopen');
    }

    expandMenu () {
        const { $ } = window;
        $('html').removeClass('menucollapsed');
        this.closeUserMenu();
    }

    collapseMenu () {
        const { $ } = window;
        $('html').addClass('menucollapsed');
    }

    toggleMenuCollapse () {
        const { $ } = window;
        $('html').hasClass('menucollapsed') ? this.expandMenu() : this.collapseMenu();
    }

    logout () {
        this.ModalService.confirm(this.$translate.instant('general.Are you sure you want to log out?'), 'small')
            .then(() => {
                this.AuthService.logoutAndRedirect();
            })
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/header/private/index.js